import classNames from "classnames";
import Checkbox from "components/checkbox";
import { SELECTABLE_CHECKBOX_TEST_ID } from "constants/test";
import { FunctionComponent } from "react";

interface SelectableProps
  extends Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "onSelect"> {
  isSelected: boolean;
  onSelect: (val: boolean) => void;
}

const Selectable: FunctionComponent<SelectableProps> = ({ isSelected, onSelect, className, children, ...divProps }) => {
  return (
    <div {...divProps} className={classNames("relative group", className)}>
      <Checkbox
        data-testid={SELECTABLE_CHECKBOX_TEST_ID}
        className={classNames("absolute top-2 right-2 z-10", { "opacity-0 group-hover:opacity-100": !isSelected })}
        setValue={onSelect}
        value={isSelected}
      />
      {children}
    </div>
  );
};

export default Selectable;
